import { render, staticRenderFns } from "./SimplifiedOnboardingModal.vue?vue&type=template&id=a423d5d8&scoped=true&"
import script from "./SimplifiedOnboardingModal.vue?vue&type=script&lang=js&"
export * from "./SimplifiedOnboardingModal.vue?vue&type=script&lang=js&"
import style0 from "./SimplifiedOnboardingModal.vue?vue&type=style&index=0&id=a423d5d8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a423d5d8",
  null
  
)

export default component.exports